import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const StartingAConversationAboutMh = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.startingAConversationAboutMhBody}
      />
    </ArticleBody>
  </div>
);

StartingAConversationAboutMh.propTypes = {};

export default StartingAConversationAboutMh;
